<div class="kw-page" [nbSpinner]="isLoading">

  <button mat-button class="back-btn" type="button" (click)="back()">
    <fa-icon [icon]="faArrowLeft" class="me-2"></fa-icon>Back
  </button>

  <div class="kw-page-header">
    <div>
      <h1 class="page-title">Move to Order</h1>
      <div class="page-subtitle">Assign quantities from the selected units to an order.</div>
    </div>
  </div>

  <section class="detail-card order-card" aria-labelledby="orderTitle">
    <div class="section-head">
      <fa-icon [icon]="faFileLines" class="section-icon"></fa-icon>
      <h3 id="orderTitle">Order</h3>
    </div>
    <div class="order-row">
      <mat-form-field appearance="outline" class="order-field">
        <mat-label>Order Barcode</mat-label>
        <fa-icon matPrefix [icon]="faBarcode" class="barcode-icon"></fa-icon>
        <input type="text" matInput [(ngModel)]="orderNumberSearch" (keyup.enter)="searchOrder()" autocomplete="off">
      </mat-form-field>
      <button mat-stroked-button class="find-btn" type="button" (click)="searchOrder()">
        <fa-icon [icon]="faMagnifyingGlass" class="me-2"></fa-icon>Find Order
      </button>
      <div class="order-found" role="status" *ngIf="selectedOrder; else orderHint">
        <fa-icon [icon]="faCheck"></fa-icon>Order unit <b>{{selectedOrder.barcode}}</b> found
      </div>
      <ng-template #orderHint>
        <div class="order-hint">Scan or type an order barcode, then press Enter.</div>
      </ng-template>
    </div>
  </section>

  <section class="detail-card units-card" aria-label="Units to assign"
    *ngIf="session.handlingUnitBulkMoveList?.length; else noUnits">
    <div class="toolbar">
      <span class="unit-count"><b>{{session.handlingUnitBulkMoveList.length}}</b> units</span>
      <span class="count-pill">{{selectionLabel}}</span>
      <span class="toolbar-hint">Qty to Assign can't exceed Available.</span>
    </div>

    <div class="grid-card">
      <ejs-grid #grid [dataSource]="session.handlingUnitBulkMoveList" [allowPaging]="true" [pageSettings]="pageSettings"
        [allowSorting]="true" [filterSettings]="filterSettings" [allowFiltering]="true"
        [selectionSettings]="selectionOptions" [editSettings]="{allowEditing: true, mode: 'Batch'}"
        (cellSave)="onCellSave($event)" (checkBoxChange)="onGridSelectionChange()" height="500">
        <e-columns>
          <e-column type='checkbox' width='60'></e-column>
          <e-column field='tagNumber' headerText='Barcode' width='140' [allowEditing]="false"></e-column>
          <e-column field='details' headerText='Details' width='180' [allowEditing]="false"></e-column>
          <e-column field='lot' headerText='Lot' width='140' [allowEditing]="false"></e-column>
          <e-column field='warehouseName' headerText='Warehouse' width='140' [allowEditing]="false"></e-column>
          <e-column field='roomName' headerText='Room' width='140' [allowEditing]="false"></e-column>
          <e-column field='roomLocationName' headerText='Location' width='140' [allowEditing]="false"></e-column>
          <e-column field='availableQuantity' headerText='Available' width='110' textAlign='Right' [allowEditing]="false"></e-column>
          <e-column field='quantity' headerText='Qty to Assign' width='130' textAlign='Right' [customAttributes]="{class: 'assign-cell'}"
            editType='numericedit' [edit]="{params: {min: 0, validateDecimalOnType: true}}"></e-column>
        </e-columns>
      </ejs-grid>
    </div>

    <!-- Phones / iPad portrait: one card per unit -->
    <div class="kw-mobile-list">
      <div class="unit-row" *ngFor="let x of units | slice:0:mobileVisibleCount; trackBy: trackByUnit"
        [class.selected]="isMobileSelected(x)">
        <input type="checkbox" class="unit-check" [checked]="isMobileSelected(x)" (change)="toggleMobileSelection(x)"
          [attr.aria-label]="'Select ' + x.tagNumber">
        <div class="unit-info">
          <div class="unit-code">{{x.tagNumber}}</div>
          <div class="unit-sub">{{x.details}}<ng-container *ngIf="x.lot"> · Lot {{x.lot}}</ng-container></div>
          <div class="unit-sub">{{unitLocation(x)}}</div>
        </div>
        <div class="assign-qty">
          <input class="qty-input filled" type="number" inputmode="decimal" min="0" [max]="x.availableQuantity" [(ngModel)]="x.quantity"
            [attr.aria-label]="'Qty to assign for ' + x.tagNumber">
          <div class="assign-of">of {{x.availableQuantity | number}}</div>
        </div>
      </div>
      <button mat-stroked-button class="m-show-more" type="button"
        *ngIf="session.handlingUnitBulkMoveList.length > mobileVisibleCount" (click)="mobileVisibleCount = mobileVisibleCount + 50">
        Show more
      </button>
    </div>
  </section>

  <ng-template #noUnits>
    <div class="detail-card m-empty">No inventory selected for this move.</div>
  </ng-template>

  <div class="action-bar">
    <div class="action-summary">{{summary}}</div>
    <button mat-stroked-button type="button" (click)="back()">Cancel</button>
    <button mat-raised-button color="primary" type="button" [disabled]="!selectedOrder" (click)="assignToOrder()">
      <fa-icon [icon]="faTruck" class="me-2"></fa-icon>Assign to Order
    </button>
  </div>

</div>
